"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.last4 = void 0;
/**
 * - If the length of the digits is less than 5, returns the original string.
 * - If the length is 5 or more, returns last 4 digit of number.
 *
 * @param {string} input - The value to be formatted.
 * @returns {string} - The formatted digit, or original/empty string based on conditions.
 */
const last4 = (input) => {
    if (!input)
        return input;
    const digit = input.trim().replace(/[^\d]/g, "");
    if (digit.length < 5)
        return digit;
    return digit.substr(digit.length - 4);
};
exports.last4 = last4;
